import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { styled } from "@mui/material/styles";
//@ts-ignore
import img from "../images/iPhoneImage1.png";
//@ts-ignore
import imglight from "../images/iPhoneImage1_light.png";

//@ts-ignore
import imgFront from "../images/Thumbnail_Figma.jpg";

const StyledBox = styled("div")(({ theme }) => ({
	alignSelf: "center",
	width: "100%",
	height: "auto",
	marginTop: theme.spacing(8),
	borderRadius: theme.shape.borderRadius,
	outline: "6px solid",
	outlineColor: "hsla(220, 25%, 80%, 0.2)",
	border: "1px solid",
	borderColor: theme.palette.grey[200],
	boxShadow: "0 0 12px 8px hsla(220, 25%, 80%, 0.2)",

	[theme.breakpoints.up("sm")]: {
		marginTop: theme.spacing(10),
	},
	...theme.applyStyles("dark", {
		boxShadow: "0 0 24px 12px hsla(210, 100%, 25%, 0.2)",
		outlineColor: "hsla(220, 20%, 42%, 0.1)",
		borderColor: theme.palette.grey[700],
	}),
}));

export default function Hero() {
	return (
		<Box
			id="hero"
			sx={(theme) => ({
				width: "100%",
				backgroundRepeat: "no-repeat",

				backgroundImage:
					"radial-gradient(ellipse 80% 50% at 50% -20%, hsl(335 57.3% 65.1% / 0.2), transparent)",
				...theme.applyStyles("dark", {
					backgroundImage:
						"radial-gradient(ellipse 80% 50% at 50% -20%, hsl(335 57.3% 65.1% / 0.4), transparent)",
				}),
			})}
		>
			<Container
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					pt: { xs: 14, sm: 20 },
					pb: { xs: 8, sm: 12 },
				}}
			>
				<Stack
					spacing={2}
					useFlexGap
					sx={{
						alignItems: "center",
						width: { xs: "100%", sm: "70%" },
					}}
				>
					<Typography
						variant="h1"
						sx={{
							display: "flex",
							flexDirection: { xs: "column", sm: "row" },
							alignItems: "center",
							fontSize: "clamp(3rem, 10vw, 3.5rem)",
						}}
					>
						Let's&nbsp;Quit&nbsp;
						<Typography
							component="span"
							variant="h1"
							sx={{
								fontSize: "inherit",
								color: "primary.main",
							}}
							color="primary.main"
						>
							Together
						</Typography>
					</Typography>
					<Typography
						sx={{
							textAlign: "center",
							color: "text.secondary",
							width: { sm: "100%", md: "80%" },
						}}
					>
						Helping our members quit bad habits through journaling
						and community.
					</Typography>
				</Stack>
				<StyledBox id="image">
					<img src={imgFront} width={"100%"} />
				</StyledBox>
			</Container>
		</Box>
	);
}
